export default __webpack_public_path__ + "img/13452b7674ac981d35c62954e1075119.png";